<template>
  <div class="d-flex" style="align-items: center;">
    <div class="side-frame-success d-flex">
      <span style="font-size: 14px; color:#6C6C6C;line-height: 28px;">
        {{ $l('table_label_sku_product_list') || 'SKU产品列表' }}
      </span>
    </div>
    <div v-if="!disabled && isMany">
      <b-button
        class="ml-3"
        size="sm"
        variant="outline-success"
        @click="$emit('chooseAmzSkuVisible')"
        style="width:109px;"
      >
        {{ $l('INDEX.table_label_Selectexistingsku') || '选择已有Sku' }}
      </b-button>
    </div>
    <el-badge v-if="!disabled && isMany" :value="checkedCount" class="item">
      <b-button
        class="ml-2"
        size="sm"
        variant="outline-danger"
        :disabled="!checkedCount"
        @click="$emit('remove')"
        style="width:109px;"
      >
        {{ $l('btn_remove_sku') || '移除SKU' }}
      </b-button>
    </el-badge>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
}
export default {
  props: {
    disabled: { type: Boolean, default: false },
    isMany: { type: Boolean, default: false },
    checkedCount: { type: Number, default: 0 },
  },
  data() {
    return {
      form: { ...initForm },
    }
  },

  mounted() {},
  methods: {},
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}

.side-frame-success {
  padding: 1px 10px;
  border-left: 3px solid #67c23a;
  margin: 6px 0;
}
</style>
